const SUBHEAD_REF_PREFIX = 'S';

export const formatSubheadRefId = (sequenceNumber) => {
  return `${SUBHEAD_REF_PREFIX}${String(sequenceNumber).padStart(6, '0')}`.slice(0, 7);
};

export const parseSubheadRefSequence = (refid) => {
  if (!refid || typeof refid !== 'string') {
    return 0;
  }
  const match = refid.match(/^S(\d+)$/i);
  return match ? parseInt(match[1], 10) : 0;
};

export const getNextSubheadRefSequence = (existingRefids = []) => {
  const maxSeq = existingRefids.reduce(
    (max, refid) => Math.max(max, parseSubheadRefSequence(refid)),
    0
  );
  return maxSeq + 1;
};

export const getSubheadQueryResults = (response) => {
  const data = response?.data;
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data?.results)) {
    return data.results;
  }
  return [];
};
